/* global jQuery, elementorFrontend */

jQuery( window ).on( 'elementor/frontend/init', () => {

	/**
	* Revive Slider
	* Set up swiper.js instance for the Revive Slider widget
	*
	* @param $element The widget wrapper element as a jQuery element
	* @param $ The jQuery alias
	*/
	const reviveSliderHandler = ( $element, $ ) => {
		const asyncSwiper = elementorFrontend.utils.swiper;
		$element.find('.revive-slider__slider').each(function() {
			let $this = $(this);

			if( $this.find('.slide-entry-container').length > 1 ) {
				let dataID = $element.data('id');
				let columnCount = $this.data('columncount');
				
				var swiperSettings = {
					allowTouchMove: true,
					loop: false,
					slidesPerView: 1,
					spaceBetween: 16,
					speed: 350,
					navigation: {
						nextEl: $element.find('.revive-slider__next'),
						prevEl: $element.find('.revive-slider__prev')
					},
					breakpoints: {
						481: {
							allowTouchMove: false,
							preventClicks: false,
							preventClicksPropagation: false,
							preventInteractionOnTransition: true,
							slidesPerView: Math.max( (columnCount - 2), 1),
							spaceBetween: 24
						},
						768: {
							allowTouchMove: false,
							preventClicks: false,
							preventClicksPropagation: false,
							preventInteractionOnTransition: true,
							slidesPerView: Math.max( (columnCount - 1), 1),
							spaceBetween: 24
						},
						980: {
							allowTouchMove: false,
							preventClicks: false,
							preventClicksPropagation: false,
							preventInteractionOnTransition: true,
							slidesPerView: columnCount,
							spaceBetween: 24
						}
					},
					pagination: {
						clickable: true,
						el: $element.find('.revive-slider__pagination'),
						type: 'bullets'
					}
				};
				
				window["reviveSwiper_"+dataID] = new asyncSwiper($this, swiperSettings);
			}
		});
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/revive-slider.default', reviveSliderHandler );

} );